import React from "react";

import { Container, Row, Col } from "reactstrap";

import Layout from "./Layout";

const ComingSoon = () => {
	return (
		<Layout>
			<Container>
				<Row className="mt-4">
					<Col>
						<h3>Coming Soon</h3>
						<p>
							This is the placeholder for the T. Rowe Price California Consumer
							Privacy Act (CCPA) webpage which will launch January 1, 2020.
						</p>
						<p>
							CCPA rights are available only to Consumers who currently reside
							in California.
						</p>
						<p>
							If you are a California Consumer, feel free to return January 1,
							2020 for further information.
						</p>
					</Col>
				</Row>
			</Container>
		</Layout>
	);
};

export default ComingSoon;
